(
    window as unknown as { process?: { nextTick: (fn: (...args: unknown[]) => void, ...args: unknown[]) => void } }
).process = {
    nextTick: (fn: (...args: unknown[]) => void, ...args: unknown[]): ReturnType<typeof setTimeout> =>
        setTimeout(() => {
            fn(...args);
        }, 0),
};

import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config';

bootstrapApplication(App, appConfig).catch((error: unknown) => {
    console.error(error);
});
